import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { ProductCard } from './ProductCard';
import { Product } from '../../../data/Product';

type ProductListProps = {
    productList: Product[],
    onClick: (product: Product) => void,
};

ProductList.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
}));

function ProductList(props: ProductListProps): React.ReactElement {
    const {
        onClick,
        productList,
    } = props;
    const classes = useStyle();

    return (
        <div className={classes.root}>
            {productList.map((item) => (
                <ProductCard product={item} onClick={onClick} />
            ))}
        </div>
    );
}

export { ProductList };
